// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getFirestore } from 'firebase/firestore'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBw-GfvUvPWIF5b8WiRATM7PNLsvdqF9dI',
  authDomain: 'roibby.firebaseapp.com',
  projectId: 'roibby',
  storageBucket: 'roibby.appspot.com',
  messagingSenderId: '107170498828',
  appId: '1:107170498828:web:c61900683752cd948f2129',
  measurementId: 'G-68GKD1XNQ9'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
export const db = getFirestore(app)